import { render } from "./Datastore.vue?vue&type=template&id=3361d4de"
import script from "./Datastore.vue?vue&type=script&lang=js"
export * from "./Datastore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__